import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectOperacionState, selectDetalleFacturaState } from 'app/store/app.states';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { Observable } from 'rxjs';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
import { filter } from 'rxjs/operators';
import { filters } from '../../../../mock-api/apps/mailbox/data';
import { messages } from '../../../../mock-api/apps/chat/data';
import { PagosComponent } from '../pagos/pagos.component';

interface Food {
    value: string;
    viewValue: string;
}
const datosTabla1: any[] = [

];
@Component({
    selector: 'app-complemento-pago',
    templateUrl: './complementoPago.component.html',
    styleUrls: ['./complementoPago.component.scss']
})

export class ComplementoPagoComponent implements OnInit, OnDestroy {
    /**IMPUTUS OUTPUTS */
    @Input() ltsMoneda: any[];
    @Input() ltsMetodoPago: any;
    @Output() countPagosEventEmiter = new EventEmitter<any>();
    @Output() countPagosValidaDatosEventEmiter = new EventEmitter<any>();
    @Input() ltsFormaPago: any[];
    @Input() banderaActualizarFactura: boolean;
    @Input() allDataPago: any;
    @Input() ltsObjetoImpuesto: any[];
    /**IMPUTUS OUTPUTS */

    getStateOperacion: Observable<any>;
    subscribeOperacion: any;
    idOperacion: number;
    Operacion: any;
    getStateDetalleFactura: Observable<any>;
    complementoPagoForm: FormGroup;

    countPagos: { id: string, child?: PagosComponent }[] = [{ id: `Pago 1`, child: null }];
    removeDisabled: boolean = true;
    dataUpdateComplemento: any = []

    constructor(
        private readonly store: Store<AppState>,
        private fb: FormBuilder,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder,
        private _snackBar: MatSnackBar,
        private srvcoal: CoalService
    ) {
    }
    ngOnDestroy(): void {
        this.baseService.postDetalleFactura(null);
    }

    ngOnInit(): void {
        console.log("int",this.ltsObjetoImpuesto)
        this.getStateOperacion = this.store.select(selectOperacionState);
        // this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
        //     this.idOperacion = operacion.idOperacion;
        //     this.Operacion = operacion;
        // });
        this.getStateDetalleFactura = this.store.select(selectDetalleFacturaState);

        if (this.banderaActualizarFactura) {
            this.countPagos = [];
            for (let data of this.allDataPago) {
                setTimeout(() => {
                    this.countPagos.push({ id: `Pago ${this.countPagos.length + 1}` });
                    console.log("data pago",data)
                    this.dataUpdateComplemento = data ;
                }, 10);
            };
        };
    };

    addPago = () => {
        if(this.banderaActualizarFactura){
            this.dataUpdateComplemento = [];
        }
        this.countPagos.push({ id: `Pago ${this.countPagos.length + 1}` });
        this.countPagos.length <= 1 ? this.removeDisabled = true : this.removeDisabled = false;
    };

    removePago = () => {
        if(this.banderaActualizarFactura){
            this.dataUpdateComplemento = [];
        }
        
        // Obtener el arreglo existente de documentos
        let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
        // Filtrar el documento que se va a eliminar
        allDocs = allDocs.filter(doc => doc.lsnombre !== 'Pago ' + this.countPagos.length);
        // Guardar el arreglo actualizado en el localStorage
        localStorage.removeItem('allDocs');
        localStorage.setItem('allDocs', JSON.stringify(allDocs));

        localStorage.removeItem('Pago ' + this.countPagos.length);
        this.countPagos.splice(-1);
        this.countPagos.length <= 1 ? this.removeDisabled = true : this.removeDisabled = false;


        
    };

    insertDataComplementoPago = () => {
        console.log("insertDataComplementoPago");

        this.countPagosEventEmiter.emit(this.countPagos);
    };

    validaDatosComplemento = () => {
        this.countPagosValidaDatosEventEmiter.emit(this.countPagos);
    };

    validaComplementoPago = () => {
        console.log("validando complementoPagos");
        let pagoValid = true;
        this.countPagos.forEach(f => {
            const res = f.child?.validatePago() ?? true;
            pagoValid = pagoValid && res;
        });

        return pagoValid;
    };
};
